var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from "mobx";
export class GlobalAdminBillingManager {
    constructor(billingService) {
        this.billingService = billingService;
        this.isLoadingDetails = false;
        this.isLoadingSummary = false;
        this.billingDetails = null;
        this.billingSummary = null;
        this.errorMessage = null;
        this.currentOrgId = null;
    }
    async loadBillingDetails(orgId, input) {
        this.currentOrgId = orgId;
        this.isLoadingDetails = true;
        this.errorMessage = null;
        try {
            const details = await this.billingService.getBillingDetails(orgId, input);
            if (this.currentOrgId === orgId) {
                this.billingDetails = details;
                return details;
            }
            return null;
        }
        catch (error) {
            if (this.currentOrgId === orgId) {
                this.errorMessage = error instanceof Error ? error.message : "Failed to load billing details";
                this.billingDetails = null;
            }
            return null;
        }
        finally {
            if (this.currentOrgId === orgId) {
                this.isLoadingDetails = false;
            }
        }
    }
    async loadBillingSummary(orgId, input) {
        this.currentOrgId = orgId;
        this.isLoadingSummary = true;
        this.errorMessage = null;
        try {
            const summary = await this.billingService.getBillingSummary(orgId, input);
            if (this.currentOrgId === orgId) {
                this.billingSummary = summary;
                return summary;
            }
            return null;
        }
        catch (error) {
            if (this.currentOrgId === orgId) {
                this.errorMessage = error instanceof Error ? error.message : "Failed to load billing summary";
                this.billingSummary = null;
            }
            return null;
        }
        finally {
            if (this.currentOrgId === orgId) {
                this.isLoadingSummary = false;
            }
        }
    }
    clearData() {
        this.currentOrgId = null;
        this.billingDetails = null;
        this.billingSummary = null;
        this.errorMessage = null;
    }
}
__decorate([
    observable
], GlobalAdminBillingManager.prototype, "isLoadingDetails", void 0);
__decorate([
    observable
], GlobalAdminBillingManager.prototype, "isLoadingSummary", void 0);
__decorate([
    observable
], GlobalAdminBillingManager.prototype, "billingDetails", void 0);
__decorate([
    observable
], GlobalAdminBillingManager.prototype, "billingSummary", void 0);
__decorate([
    observable
], GlobalAdminBillingManager.prototype, "errorMessage", void 0);
__decorate([
    action
], GlobalAdminBillingManager.prototype, "loadBillingDetails", null);
__decorate([
    action
], GlobalAdminBillingManager.prototype, "loadBillingSummary", null);
__decorate([
    action
], GlobalAdminBillingManager.prototype, "clearData", null);
